import classNames from 'classnames'
import * as React from 'react'
import { SVG_Cross } from '../svg/SVG_Cross'
import { SVG_Warning } from '../svg/SVG_Warning'

interface Props {
    message: string
    onClear?: () => void
    className?: string
    messageClassName?: string
}

export function Warning({ message, onClear, className, messageClassName }: Props) {
    return (
        <div className={classNames('AppCore__ui__Warning', className)}>
            <div className="AppCore__ui__Warning__icon">
                <SVG_Warning color="var(--orange-400)" height="16" width="16" />
            </div>
            <div className={classNames('AppCore__ui__Warning__message', messageClassName)}>{message}</div>
            {onClear && (
                <div className="AppCore__ui__Warning__clear" onClick={onClear}>
                    <SVG_Cross />
                </div>
            )}
        </div>
    )
}
